import { lazy } from 'react';

export const LazyError = lazy(() => import('./Error'));